var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleBlue4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0a5ec0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 19.891h-1.916V23h-3.29v-3.109H9v-2.206L15.98 8h3.104v9.429H21zm-5.205-2.462v-2.545a39 39 0 0 1 .01-.851l.044-.985q.023-.493.044-.872.033-.39.043-.544h-.087q-.207.42-.435.82-.229.39-.534.822l-2.918 4.155z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleBlue4);
export default __webpack_public_path__ + "static/media/icon-circle-blue-4.41a95c11c943dd8b75852552b6a08408.svg";
export { ForwardRef as ReactComponent };